import tradeBlockDataStore from "@/store/tradeBlockDataStore";

/**
 * Get the checked state for NPV/Recoupon checkbox from Zustand store
 * Used by valueFormatter for copy/paste functionality
 */
function getUnwindCheckedState(
  esid: string,
  blockId: number,
  field: "npv" | "recoupon",
): boolean {
  const currentTradeBlockData = tradeBlockDataStore.getState().tradeBlockData;
  const theseBlocks = currentTradeBlockData.find(
    (blocks) => blocks.esid === esid,
  );
  const thisBlock = theseBlocks?.blocks?.find((block) => block.id === blockId);

  if (!thisBlock || thisBlock.instrumentType !== "SWP") {
    return false;
  }

  if (field === "npv") {
    return thisBlock.unwind === "NPV";
  } else {
    return thisBlock.unwind === "Recoupon";
  }
}

/**
 * AG Grid valueFormatter for NPV column copy/paste
 */
export function npvValueFormatter(params: any): string {
  const esid = params.colDef?.cellRendererParams?.fullTradeData?.esid;
  const blockId = params.data?.id;

  if (!esid || blockId == null) {
    return "";
  }

  const isChecked = getUnwindCheckedState(esid, blockId, "npv");
  return isChecked ? "true" : "false";
}

/**
 * AG Grid valueFormatter for Recoupon column copy/paste
 */
export function recouponValueFormatter(params: any): string {
  const esid = params.colDef?.cellRendererParams?.fullTradeData?.esid;
  const blockId = params.data?.id;

  if (!esid || blockId == null) {
    return "";
  }

  const isChecked = getUnwindCheckedState(esid, blockId, "recoupon");
  return isChecked ? "true" : "false";
}
